import StereoPannerNode from "stereo-panner-node";

StereoPannerNode.polyfill();



// WEBPACK FOOTER //
// ./src/polyfills.js